<template>
    <div>
        <div class="filter-title d-flex align-items-center mb-2">
            <h5 v-if="filter.title" class="filter-title mb-0">
                {{ filter.title }}
            </h5>
        </div>
        <div class="row mb-2 filter-range-date">
            <div class="col">
                <!-- Date from -->
                <date-input
                    :with-time="filter.withTime"
                    :val="filterStart.value"
                    :placeholder="filterStart.text"
                    :id="filterStart.fKey"
                    :tabindex="filter.inactive ? -1 : 0"
                    :lock-past-days="filterStart.lockPastDays"
                    :lock-future-days="filterStart.lockFutureDays"
                    @change="onChangeRangeDateFrom($event)"
                />
            </div>
            <div class="col">
                <!-- Date to -->
                <date-input
                    :with-time="filter.withTime"
                    :val="filterEnd.value"
                    :placeholder="filterEnd.text"
                    :id="filterEnd.fKey"
                    :tabindex="filter.inactive ? -1 : 0"
                    :lock-past-days="filterEnd.lockPastDays"
                    :lock-future-days="filterEnd.lockFutureDays"
                    @change="onChangeRangeDateTo($event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import filterMixin from './filter.mixin'

export default {
    mixins: [filterMixin],

    props: {
        filters: {
            type: Object,
            required: true
        },
        moduleName: {
            type: String,
            required: true
        }
    },

    computed: {
        filterStart() {
            return Object.values(this.filter.filters).find(
                el => el.range === 'from'
            )
        },
        filterEnd() {
            return Object.values(this.filter.filters).find(
                el => el.range === 'to'
            )
        }
    },

    methods: {
        setFilter(key, value) {
            this.$emit('set-filter-by-key', {
                key,
                value
            })
        },
        onChangeRangeDateFrom(value, idx, filter) {
            const { moduleName } = this
            const fKey = this.filterStart.fKey
            this.setFilter(fKey, value)

            const from = this.filterStart.value
            const dataTo = this.filterEnd
            const keyTo = this.filterEnd.fKey

            if (moment(dataTo.value).isBefore(moment(from))) {
                this.setFilter(keyTo, null)
            }

            if (this.filter.lockRangeDaysNumber) {
                this.$store.dispatch('setFilter', {
                    filter: keyTo,
                    value: [moment(from).format('YYYY-MM-DD')],
                    moduleName,
                    key: 'lockPastDays'
                })
                const addLockRangeDaysNumber = moment(from).add(
                    filter.lockRangeDaysNumber,
                    'days'
                )
                this.$store.dispatch('setFilter', {
                    filter: keyTo,
                    value: addLockRangeDaysNumber.isBefore(moment())
                        ? [addLockRangeDaysNumber.format('YYYY-MM-DD')]
                        : [moment().format('YYYY-MM-DD')],
                    moduleName,
                    key: 'lockFutureDays'
                })
            }
        },
        onChangeRangeDateTo(value) {
            const { moduleName } = this
            const fKey = this.filterEnd.fKey
            this.setFilter(fKey, value)

            if (this.filter.lockRangeDaysNumber) {
                this.$store.dispatch('setFilter', {
                    filter: fKey,
                    value: [
                        moment(value)
                            .subtract(this.filter.lockRangeDaysNumber, 'days')
                            .format('YYYY-MM-DD')
                    ],
                    moduleName,
                    key: 'lockPastDays'
                })
                this.$store.dispatch('setFilter', {
                    filter: fKey,
                    value: [moment(value).format('YYYY-MM-DD')],
                    moduleName,
                    key: 'lockFutureDays'
                })
            }
        }
    }
}
</script>